module.exports = __webpack_public_path__ + "img/ic-instagram.73b5fb0e.svg";